export function EditFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.735 3.879a2.999 2.999 0 014.242 0l.141.141a3.001 3.001 0 010 4.244l-.847.848-4.385-4.384.849-.85zM13.472 6.142L3.292 16.325a1 1 0 00-.292.707v2.97a1 1 0 001 1.001h2.97a1 1 0 00.706-.293l10.18-10.184-4.384-4.384z"
      ></path>
    </svg>
  );
}
